// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__idfPe","loading__icon":"Loading_loading__icon__3hTVJ","loading-small":"Loading_loading-small__1ZByf"};